import axios from 'axios';
import { MediaItemType, QueryParameterType } from '@/composables/state/mediaSearchApp';
import { setParamIfNotNull } from '@/config/common';

if (!import.meta.env.VITE_APP_HOME_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_HOME_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_HOME_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});

const getQueryParams = (inParams:QueryParameterType) => {
  const params:Record<string, any> = {};

  setParamIfNotNull(inParams, params, 'category');
  setParamIfNotNull(inParams, params, 'subject');
  setParamIfNotNull(inParams, params, 'media');
  setParamIfNotNull(inParams, params, 'postedBy');
  setParamIfNotNull(inParams, params, 'tags');
  /* for tags, it stores as /a/ABC, need to double check this */
  if (params.tags != null) {
    const tags = params.tags;
    params.tags = `/${tags.substring(0, 1).toLowerCase()}/${tags}`;
  }
  setParamIfNotNull(inParams, params, 'searchText', 'searchKey');
  return params;
};
export async function searchMedias (inParams:QueryParameterType) {
  const apiFct = '/.ajax/media-story/query-data?rootPath=/abmi-home/connect/media-story-hub'; // '/.rest/website/?hideInNav=false&orderBy=@path'; // asc,postDate desc';
  const params = getQueryParams(inParams);

  /* get featured items, don't cluded in the pagination count */
  params.page = inParams.page;
  params.itemPerPage = inParams.itemPerPage;
  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data ?? [];
    // console.log({ c: [...data.results.map((x: MediaItemType) => ({ ...getImageRendition(x), isFeatured: false })), ...featured] });
    return {
      totalRecord: data.totalRecord,
      startPage: inParams.page,
      totalPage: data.totalPage,
      results: data.items.map((x: MediaItemType) => ({ ...x, isFeatured: x.id?.indexOf('/featured/') !== -1 }))
    };
  } catch (error) {
    console.error(error);
    return { result: [], totalRecord: 0, startPage: 0, totalPage: 0 };
  }
}

export async function getMediaMetadataTally (inParams:QueryParameterType) {
  const apiFct = '/.ajax/media-story/get-tags'; // '/.rest/website/?hideInNav=false&orderBy=postDate desc';
  const params = getQueryParams(inParams);

  /* get featured items, don't cluded in the pagination count */
  params.rootPath = inParams.rootPath ?? '/abmi-home/connect/media-story-hub';
  params.offset = 0;
  params.limit = 10000000;

  /*   category?: string[];
  media?: string;
  subject?: string[];
  */
  try {
    const response = await abmiAxios.get(apiFct, { params });
    return response.data;
  } catch (e) {
    console.error(e);
  }
}
/* get all media, and do counting */
// export async function getMediaTags () {
//   // return getMediaMetadataTally();
//   return tagOptions;
// }
// const abmiApi = {
//   searchMedias,
//   getMediaMetadataTally
// };

// export default abmiApi;
